import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { ColumnsDropzone } from 'components/ui/index';
import { DropTarget } from 'react-dnd';
import { compose } from 'redux';
import { getI18ns, filterBy } from 'components/hoc/index';
import { notification } from 'antd';
import { moveToZone } from '../../flow/actions';
import { CommonDraggableTag } from '../index';

const { FieldTypesInArray, DROPZONES } = Enums;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;

const propTypes = {
  isOver: PropTypes.bool.isRequired,
  filteredData: PropTypes.array.isRequired,
  i18ns: PropTypes.object.isRequired,
};

class OthersZone extends PureComponent {

  render() {
    const {
      isOver,
      connectDropTarget,
      filteredData,
      i18ns,
      selectedCols,
    } = this.props;
    const cols = _.filter(selectedCols, c => c && c.belongTo === OTHERS);

    return connectDropTarget(
      <div>
        <ColumnsDropzone
          isOver={isOver}
          description={<span>{i18ns.description}</span>}
          zoneTitle={i18ns.description}
        >
          {cols.map((record, i) => (
            <CommonDraggableTag
              key={record.id}
              {...record}
              index={i}
              // WARNING: Because record is an instance, all properties of the instance is accessed by getter, we have to explicit pass all necessary props on the component.
              //          Otherwise will cause issue when DnD internal access on some props.
              id={record.id}
              name={record.name}
              type={record.type}
              label={record.label}
              disabled={record.disabled}
              belongTo={record.belongTo}
              restriction={record.fieldRestricted}
              fieldDeleted={record.fieldDeleted}
            />
          ))}
        </ColumnsDropzone>
      </div>,
    );
  }
}

const spec = {
  drop: (props, monitor) => {
    // get item id from drag source
    const { id, belongTo } = monitor.getItem();
    const { i18ns, selectedCols } = props;
    if (_.isArray(selectedCols) && selectedCols.length >= 10 && belongTo !== DROPZONES.OTHERS) {
      notification.error({
        duration: 3,
        message: i18ns.totalMax
      });
    } else {
      props.moveToZone(DROPZONES.OTHERS, id);
    }
  },
};
const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver(),
});
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  data: reportSetup.sider.availableColumns,
  selectedCols: reportSetup.sider.selectedCols,
});
const mapDispatchToProps = {
  moveToZone,
};

const enhancers = compose(
  // FIXME: if we put getI18ns after connect, because getI18ns has its own connect()(), so the mapStateToProps here will be override by the one in getI18ns.
  //        Ideally, those should be merged not replace.
  getI18ns({
    description: 'page.ReportTableSetup.descriptions.others',
    totalMax: 'page.ReportFilters.errors.totalMax',
  }),
  connect(mapStateToProps, mapDispatchToProps),
  DropTarget(FieldTypesInArray, spec, collect),
  filterBy(
    'data',
    record => record.belongTo === DROPZONES.OTHERS,
  ),
);

OthersZone.propTypes = propTypes;
export default enhancers(OthersZone);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/OthersZone/index.jsx